/**
 * @deprecated This was a (failed) attempt to organise our z-indexes, but it
 * looks like using the Chakra defaults is working out better, it's just that
 * they're not very discoverable.
 *
 * See {@link https://github.com/chakra-ui/chakra-ui/blob/29322fcd0d0d598c8d3599d098a44c88f6395d2c/packages/react/src/theme/tokens/z-indices.ts | the Chakra source }
 * for a list of possible strings you can use, e.g. "overlay" or "popover".
 */
export const deprecatedZIndexes = {
  Z_INDEX_MAIN_NAV_MENUS: 7,
  Z_INDEX_SUBNAV: 6,
  // The recording indicator needs to be on top of everything except the main menus
  Z_INDEX_RECORDING_INDICATOR: 6,
} as const
